"use client";

export default function FootballFilterOddsAndBookmaker({
  extendValue,
  bookmakerValue,
  extendOptions,
  bookmakerOptions,
  onExtendChange,
  onBookmakerChange,
}) {
  const arrowSvg = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 20 20'%3E%3Cpath fill='%23626262' d='M5.3 7.3a1 1 0 0 1 1.4 0L10 10.6l3.3-3.3a1 1 0 1 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4Z'/%3E%3C/svg%3E`;

  const selectStyle = {
    WebkitAppearance: "none",
    MozAppearance: "none",
    appearance: "none",
    backgroundImage: `url("${arrowSvg}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 10px center",
    backgroundSize: "12px 12px",
    paddingRight: 30,
  };

  return (
    <div className="flex items-center justify-end gap-[6px]">
      <form action="" method="get">
        <select
          className="bg-[var(--theme-foreground)] text-[13px] leading-[18px] text-[var(--theme-text)]"
          style={selectStyle}
          name="extend_value"
          value={String(extendValue ?? "")}
          onChange={(e) => onExtendChange?.(e.target.value)}
        >
          {(extendOptions ?? []).map((opt) => (
            <option key={String(opt.value)} value={String(opt.value)}>
              {opt.label}
            </option>
          ))}
        </select>
      </form>

      <form action="" method="get" id="form-change-company">
        <select
          className="bg-[var(--theme-foreground)] text-[13px] leading-[18px] text-[var(--theme-text)]"
          style={selectStyle}
          name="company_id"
          id="change-company"
          value={String(bookmakerValue ?? "")}
          onChange={(e) => onBookmakerChange?.(e.target.value)}
        >
          {(bookmakerOptions ?? []).map((opt) => (
            <option key={String(opt.value)} value={String(opt.value)}>
              {opt.label}
            </option>
          ))}
        </select>
      </form>
    </div>
  );
}

